export const RESET_REDUCERS = 'RESET_REDUCERS'

export default (state = {}, action) => {
  switch (action.type) {
    case RESET_REDUCERS:
      return {
        ...action.state
      }
    default:
    return {
      ...state,
    }
  }
}
